const approvalStatusOptions = [
  { label: "Approved", value: "APPROVED", type: "success" },
  { label: "Pending", value: "PENDING", type: "warning" },
  { label: "Rejected", value: "REJECTED", type: "danger" },
];

export default approvalStatusOptions;
